import React from 'react';

const jobData = {
    companies: [
        {
            startDate: '12--2021',
            companyName: 'Microsoft',
            url: 'https://www.microsoft.com/en-us/',
            title: 'Software Engineer',
            location: 'Redmond, WA',
            range: 'December 2021 - present',
            roleDescription: [
                <>Led end-to-end development on the <a href="https://learn.microsoft.com/en-us/azure/logic-apps/workflow-assistant-standard" target="_blank" rel="noopener noreferrer" style={{color: '#77ddaa', textDecoration: 'none', borderBottom: '1px solid #77ddaa'}}>Workflow Assistant</a>, an AI-powered chatbot to assist workflow creation</>,
                <>Built <a href="https://learn.microsoft.com/en-us/azure/logic-apps/create-autonomous-agent-workflows?tabs=standard" target="_blank" rel="noopener noreferrer" style={{color: '#77ddaa', textDecoration: 'none', borderBottom: '1px solid #77ddaa'}}>agentic capabilities</a> including autonomous agent workflows to enable intelligent automation</>,
                <>Transitioned overburdened Azure Logic App service to a <a href="https://github.com/Azure/LogicAppsUX" target="_blank" rel="noopener noreferrer" style={{color: '#77ddaa', textDecoration: 'none', borderBottom: '1px solid #77ddaa'}}>new open source designer</a> application, reducing load time by over 70%</>,
                'Built a dependent service by multiple partner teams to provide a seamless experience for users',
                'Mentored multiple interns and new-hires on Logic Apps Projects: Unit Testing Workflows and Copilot',
            ],
        },
        {
            startDate: '01-20-2021',
            companyName: 'Bank of America',
            url: 'https://about.bankofamerica.com/en/our-company',
            title: 'Software Engineer',
            location: 'Charlotte, NC',
            range: 'January 2021 - November 2021',
            roleDescription: [
                'Revamped long-standing credit risk platform to use a microservice architecture, substantially reducing load time',
                "Transitioned the web app's Spring framework to Node's Express to maintain continuity between front and backend",
                'Developed new features including UI/UX changes using React, creation of APIs using Knex and Objection, construction of Oracle Exadata scripts, and contributions to the bank’s reusable component library',
                'Utilized Jest and React-testing-library for unit testing, RAFT for automated functional testing, and Jenkins for integration testing and deployment',
                'Worked with container deployment platforms including OpenShift and Ansible',
            ],
        },
        {
            startDate: '05-10-2019',
            companyName: 'Pfizer',
            url: 'https://www.pfizer.com/',
            title: 'Software Developer Intern',
            location: 'New York, NY',
            range: 'May 2019 - August 2019',
            roleDescription: [
                'Enhanced the visualization capabilities for a natural language processing prototype for the Competitive Intelligence Team to empower rapid trend analysis to form business insights',
                'Drastically improved the rendering capabilities of massive network graphs to be able to handle thousands of nodes from dozens by reducing CPU and memory usage',
                'Implemented improvements to the backend microservices of the project to further analyze the clinical studies',
                'Utilized popular JavaScript libraries including React-Redux.js, Node.js, Webpack.js, D3.js, and Sigma.js',
            ],
        },
        {
            startDate: '12-1-20',
            companyName: 'China Unicom',
            url: 'https://www.chinaunicomglobal.com/us/',
            title: 'Software Engineer Intern',
            location: 'Shanghai',
            range: 'December 2018 - January 2019',
            roleDescription: [
                'Developed an app that utilized Spring Data JPA to fetch and create APIs to relay potential errors of the surveillance system to a GUI built with JavaFX',
                'Assisted developers to create a file system for customer database management; responsible for functional and unit testing',
            ],
        },
    ],
};

export default jobData;
